import React, {useEffect} from 'react'
import WebFont from 'webfontloader';
// eslint-disable-next-line
import {BrowserRouter as Router, Switch, Route, Link} from "react-router-dom";
import {Container, Row, Card, Button, Form, Dropdown, DropdownButton, Badge, Col} from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faPlusCircle, faUsers, faEye, faUser, faSearch, faBusinessTime, faIndustry} from '@fortawesome/free-solid-svg-icons'
import NavBar from "../navbar/Navbar";
import SubNavBarC from "../navbar/SubNavbarCustomers";
import SubNavBarD from "../navbar/SubNavbarDefendants";
import {get, post} from '../../../controllers/endpoints.controller';
import {getUserToken, logout} from '../../../controllers/user.controller';
import { colors } from '../../../tools/constants';

export default function Business(props){

    const PAGE_TITLE = "Personas jurídicas";
    const PAGE_ICON = faIndustry;
    const [tableColumns, setTableColumns] = React.useState([]);
    const [tableRows, setTableRows] = React.useState([]);
    
    useEffect(() => {
        WebFont.load({
            google: {
                families: ['Roboto:100,300,400']
            }
        });

        document.title = `Gestión de deudas - ${PAGE_TITLE}`;
        getBusiness();
    }, []);

    const handleSearch = async function(event){
        const chain = {
            chain: event.target.value
        };
        const req = await post(`/${props.customers ? 'customers' : 'defendants'}/business/search`, getUserToken(), chain);
        const res = await req.json();

        if(req.status === 200){
            console.log(res)
            processBusiness(res)
        }else if(req.status === 403){
            logout();
        }else{
            alert(res.message);
            console.log(res)
        }
    }


    const getBusiness = async function(status){
        const req = await get(`/${props.customers ? 'customers' : 'defendants'}/business/`, getUserToken());
        const res = await req.json();

        if(req.status === 200){
            processBusiness(res)
        }else if(req.status === 403){
            logout();
        }else{
            alert(res.message);
        }
    }

    const processBusiness = async function(data){
        let result = [];
        for(let r of data){
            //r.debts = <div><Badge bg='' className='content-table status' style={{backgroundColor: `${status['Activo']}`}}>{r.debtStatus.active}</Badge><Badge bg='' className='content-table status ms-2' style={{backgroundColor: `${status['En juicio']}`}}>{r.debtStatus.onCourt}</Badge><Badge bg='' className='content-table status ms-2' style={{backgroundColor: `${status['Cerrado']}`}}>{r.debtStatus.closed}</Badge></div>
            r.action = <Link to={`/${props.customers ? 'clientes' : 'demandados'}/empresas/detalles/?id=${r.id}`}><Button className='' variant="primary"><FontAwesomeIcon icon={faEye} /></Button></Link>;
            r.code = <Badge bg='' className='me-2 content-table status' style={{backgroundColor: `${r.color}`}}>{r.code}</Badge>;
            result.push(r);
        }
        setTableRows(result);
        setupTable();
    }

    const setupTable = function(){
        const cols = ['Razón social', 'Código', 'Orden', 'Localidad', 'Detalle'];
        setTableColumns(cols);
    };

    return(
        <div className='p-0' style={{fontFamily: 'Roboto'}}>
            <style>{'body {background-color: #EBEBEB !important;}'}</style>
            <NavBar/>
            {props.customers ? <SubNavBarC/> : <SubNavBarD/>}

            <div style={{height: 300, background: '#FAFAFA'}}>
                <Container>
                    <Row style={{paddingTop: 10}}>
                        <table className='w-75' style={{marginLeft: 'auto', marginRight: 'auto'}}>
                            <tr>
                                <td style={{fontSize: 45, fontWeight: 300}}>
                                    <p className='m-0' style={{color: '#A0A0A0', fontSize: 25, fontWeight: 300}}>Contrarios</p>
                                    <p className='m-0' style={{color: '#A0A0A0', fontSize: 45, fontWeight: 300}}>{PAGE_TITLE}</p>
                                </td>
                                <td style={{fontSize: 140, width: 150}}>
                                    <FontAwesomeIcon icon={PAGE_ICON} style={{fontSize: 140, color: "A0A0A0"}} />
                                </td>
                            </tr>
                        </table>
                    </Row>
                </Container>
            </div>

            <Container>
                <Row style={{marginTop: -70}}>
                    <Card className='cards content mb-5'>
                        <table className='content-options content'>
                            <tr>
                                <td className='content-options rows left'>
                                    <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon><Form.Control className='ms-2' type="text" id="textFee" style={{width: 250, display: 'inline'}} placeholder="" onChange = {(event) => handleSearch(event)} />
                                </td>
                                <td className='content-options rows right'>
                                    <Link to={`/${props.customers ? 'clientes' : 'demandados'}/empresas/nueva`}>
                                        <Button variant="success"><FontAwesomeIcon icon={faPlusCircle} style={{marginRight: 8}} />Nueva persona jurídica</Button>
                                    </Link>
                                    
                                </td>
                            </tr>
                        </table>

                        {tableRows.length > 0 ?
                            <Container className='pt-3 mb-3'>
                                <div className='d-none d-sm-block'>
                                    <Row className=' p-2 mb-2' style={{ background: `${colors().brand_blue}`, color: 'white', borderRadius: 8 }}>
                                        <Col sm={1} className='align-center-vertically-v2'>
                                            <div>
                                                Código
                                            </div>
                                        </Col>

                                        <Col sm={5} className='align-center-vertically-v2' >
                                            <div>
                                                Razón social
                                            </div>
                                        </Col>

                                        <Col sm={2} className='align-center-vertically-v2' >
                                        <div style={{ textAlign: 'center' }}>
                                                Orden
                                            </div>
                                        </Col>

                                        <Col sm={3} className='align-center-vertically-v2' >
                                            <div style={{ textAlign: 'center' }}>
                                                Localidad
                                            </div>
                                        </Col>


                                        <Col sm={1} className='align-center-vertically-v2'>
                                            <div style={{ textAlign: 'center' }}>
                                                
                                            </div>
                                        </Col>
                                    </Row>
                                </div>

                                {tableRows.map((r, i) => (
                                    <div>
                                        <div className='d-none d-sm-block'>
                                            <Row className='p-2 mb-2' style={{ background: r.income ? '#d8eddd' : '#F0F0F0', borderRadius: 8 }}>
                                                <Col xs={1} className='align-center-vertically'>
                                                <p className='m-0'>{r.code}</p>

                                                </Col>
                                                <Col xs={5} className='align-center-vertically-v2'>
                                                    <div>
                                                        <p className='m-0'>{r.legalName}</p>
                                                    </div>

                                                </Col>
                                                <Col xs={2} className='align-center-vertically-v2'>
                                                <div style={{ textAlign: 'center' }}>
                                                        <p className='m-0'>{r.educationalNetwork != null ? r.educationalNetwork.name : "---"}</p>
                                                    </div>

                                                </Col>
                                                

                                                <Col xs={3} className='align-center-vertically-v2'>
                                                    <div style={{ textAlign: 'center' }}>
                                                        <p className='m-0'>{r.city ? r.city : "---"}</p>
                                                    </div>
                                                </Col>

                                                <Col xs={1} className='align-center-vertically-v2'>
                                                    <div style={{ textAlign: 'right' }}>
                                                        <p className='m-0'>{r.action}</p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>


                                    </div>

                                ))}
                            </Container>
                            :
                            <Container className='mt-5 mb-5'>

                                <Row style={{ height: 300, textAlign: "center" }}>
                                    <p className='' style={{ height: 40, fontSize: 100, color: "#A0A0A0", marginTop: 50 }}><FontAwesomeIcon icon={PAGE_ICON}></FontAwesomeIcon></p>
                                    <p className='m-0' style={{ fontSize: 20, color: "#A0A0A0" }}>No se encontraron personas jurídicas</p>
                                </Row>
                            </Container>

                        }
                    </Card>
                </Row>
            </Container>
        </div>
    )
}